import Gravity from 'Gravity';

export default class SearchType {
    constructor(element, parent) {
        this.parent = parent;
        this.element = element;
        this.input = element.querySelector('input[name="s"]');
        this.resetButton = element.querySelector('.gravity-block-filters__search-reset');
        this.submitButton = element.querySelector('.gravity-block-filters__submit');
    }

    init() {
        if (!this.parent.hasApplyButton) {
            this.input.addEventListener('input', Gravity.debounce(this.checkValue.bind(this), 350));
        }

        this.input.addEventListener('keydown', (e) => {
            const keyCode = e.which.toString();

            if (keyCode === '13') {
                e.preventDefault();

                this.sendChanges();
            }
        });

        this.resetButton.addEventListener('click', (e) => {
            e.preventDefault();

            this.clear();
            this.hideReset();
            this.sendChanges();
        });

        this.submitButton.addEventListener('click', () => {
            this.sendChanges();
        });

        this.updateInitialValue();
    }

    updateInitialValue() {
        // If we have initial value then set value to the input
        if (this.parent.filterArgs.search) {
            this.input.value = this.getFilterArgs();
        }
    }

    checkValue(e) {
        const currentValue = e.target.value;

        this.toggleReset(currentValue);
        this.sendChanges();
    }

    toggleReset(value) {
        if (value.length > 2) {
            this.showReset();

            return;
        }

        this.hideReset();
    }

    showReset() {
        this.resetButton.classList.add('active');
    }

    hideReset() {
        this.resetButton.classList.remove('active');
    }

    sendChanges() {
        this.setFilterArgs();
        this.parent.sendFiltersChange(this.element);
    }

    setFilterArgs() {
        const { value } = this.input;

        this.parent.filterArgs.search = value;
    }

    getFilterArgs() {
        return this.parent.filterArgs.search;
    }

    clear() {
        this.input.value = '';
    }
}
